<template>
  <q-card flat class="bg-secondary column ml-dialog--card">
    <q-card-section
      ref="cardTitleRef"
      class="text-body1 row text-weight-medium"
    >
      <div class="text-h6 col self-center">
        <slot name="title"></slot>
      </div>
      <span class="col-auto self-start q-pl-xs" v-if="!hideClose">
        <ml-element-button
          round
          :size="10"
          text-color="surface"
          bg-color="secondary"
          icon="close"
          @click="$emit('dialog:close')"
        />
      </span>
    </q-card-section>
    <ml-separator cssClass="q-my-none"></ml-separator>
    <q-card-section
      style="max-width: 100%"
      :style="`${fullScreen ? `height:${contentHeight}px` : `max-height:${contentHeight}px`}`"
      class="overflow-auto row flex-1"
    >
      <div class="text-body2 q-gutter-y-sm full-width">
        <slot name="content"></slot>
      </div>
    </q-card-section>
    <ml-separator v-if="$slots.actions" cssClass="q-my-none"></ml-separator>
    <q-card-section
      ref="cardActionsRef"
      class="row justify-end"
      v-if="$slots.actions || acknowledge"
    >
      <div
        class="full-width"
        :class="{
          'row justify-end q-gutter-x-sm': rowActions || acknowledge,
          'col q-gutter-y-sm': colActions,
        }"
      >
        <slot v-if="$slots.actions" name="actions"></slot>
      </div>
    </q-card-section>
  </q-card>
</template>

<script setup lang="ts">
import MlSeparator from 'components/elements/separator/MlSeparator.vue'
import MlElementButton from 'components/elements/buttons/MlElementButton.vue'
import { onMounted, ref, watch } from 'vue'
import { QCardSection, useQuasar } from 'quasar'

const $q = useQuasar()
defineEmits(['dialog:close'])

const props = withDefaults(
  defineProps<{
    hideClose?: boolean
    rowActions?: boolean
    colActions?: boolean
    acknowledge?: boolean
    fullScreen?: boolean
  }>(),
  {
    hideClose: false,
    rowActions: false,
    colActions: false,
    acknowledge: false,
    fullScreen: false,
  },
)

const cardTitleRef = ref<InstanceType<typeof QCardSection> | null>(null)
const cardActionsRef = ref<InstanceType<typeof QCardSection> | null>(null)

const contentHeight = ref(0)
function calculateContentHeight() {
  const screenSize = $q.screen.height
  const titleHeight = cardTitleRef.value?.$el?.offsetHeight ?? 0
  const actionsHeight = cardActionsRef.value?.$el?.offsetHeight ?? 0
  const extraMinus = props.fullScreen ? 0 : -48
  contentHeight.value =
    screenSize -
    titleHeight -
    actionsHeight -
    (!actionsHeight ? 1 : 2) +
    extraMinus
}

watch(() => $q.screen.height, calculateContentHeight)

onMounted(() => {
  calculateContentHeight()
})
</script>
